import {AnyAction} from 'redux';
import {RECORD_ENERGY_GENERATED, RESET_ENERGY_GENERATED} from '../../actions/action';

export const getEnergyGenerated = state => state.energyGenerated;


export function energyGenerated(state: number = 0, action: AnyAction): number
{
    switch (action.type)
    {
        case RECORD_ENERGY_GENERATED:
        {
            const {payload} = action;
            const {energy} = payload;

            return (state || 0) + energy;
        }

        case RESET_ENERGY_GENERATED:
        {
            return 0;
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/mini-game/energyGenerated.ts